{
  "title": "Dawn",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "5th-level evocation",
  "level": 5,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a sunburst pendant worth at least 100 gp)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "The light of dawn shines down on a location you specify within range. Until the spell ends, a 30-foot-radius, 40-foot-high cylinder of bright light glimmers there. This light is sunlight. When the cylinder appears, each creature in it must make a Constitution saving throw, taking 4d10 radiant damage on a failed save, or half as much damage on a successful one. A creature must also make this saving throw whenever it ends its turn in the cylinder. If you’re within 60 feet of the cylinder, you can move it up to 60 feet as a bonus action on your turn."
  ],
  "spellLists": ["cleric", "wizard"]
}
